import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'antd/lib/table';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
var ListTeam = function (props) {
    props.teams.sort(function (a, b) { return (a.name).localeCompare(b.name); });
    var columns = [{
            title: 'Team name',
            dataIndex: 'name',
            key: 'name',
            sorter: function (a, b) { return (a.name).localeCompare(b.name); },
            render: function (name, team) {
                return React.createElement(Link, { to: "/event/" + props.event.subdomain + "/teams/" + team.id }, name);
            },
        }, {
            title: 'Category',
            dataIndex: 'categoryId',
            key: 'categoryId',
            render: function (categoryId) {
                var category = props.categories.find(function (c) { return c.id === categoryId; });
                return category ? category.name : '???';
            },
        }];
    return (React.createElement(Table, { rowKey: 'id', columns: columns, dataSource: props.teams, locale: {
            emptyText: 'No teams in event',
        }, pagination: { pageSize: 50 } }));
};
export default ListTeam;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListTeamPage/ListTeam.tsx
// module id = 1090
// module chunks = 0